// extracted by mini-css-extract-plugin
export default {"shareSocialWrap":"ShareSocial_shareSocialWrap__0rgeS","socialMediasBtnWrap":"ShareSocial_socialMediasBtnWrap__L1Soz"};